import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCategoriesDetails, setCategoriesLoading, setCategoriesError } from "../../../../../store/reducers/slices/categories.slice";
import { getCategories } from "../../../../../api/Categories";
import CategoriesPage from '../../../Categories'

const Categories = ({onClickTabChange = () => { }}) => {
    const dispatch = useDispatch();
    const { categoriesDetails } = useSelector(({ categories }) => categories);
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

    // API and redux
    useEffect(() => {
        // dispatch(setCategoriesLoading(true));
        const fetchData = async () => {
            try {
                let aggregate = selectedAccountId !== 'all'? false : true;
                let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
                const response = await getCategories(account_id, aggregate);
                dispatch(setCategoriesDetails(response));
                dispatch(setCategoriesLoading(false));
            } catch (error) {
                dispatch(setCategoriesLoading(false));
                dispatch(setCategoriesError(error.message));
                console.log("ERROR", error);
            }
        }

        if (selectedAccountId) {
            fetchData();
        }
        // else {
        //     dispatch(setCategoriesLoading(false));
        // }
    }, [selectedAccountId])
    return (
        <CategoriesPage onClickTabChange={onClickTabChange} />
    )
}

export default Categories